import Vue from 'vue'                               // 存放著Vue
import App from './App'                             // 存放著Vue第一層
import router from './router'                       // 存放著Vue Router
import store from './store'                         // 存放著VueX
import axios from 'axios'                           // 使用axios
import VueAxios from 'vue-axios'                    // 使用vue-axios
import BootstrapVue from 'bootstrap-vue'            // bootstrap
import Carousel3d from 'vue-carousel-3d'            // carousel-3d
import VueAwesomeSwiper from 'vue-awesome-swiper'   // Swiper
import VueLazyLoad from 'vue-lazyload'              // LazyLoad系列包含LightBox
import VeeValidate from '@/validate'              // vee表單驗證
import zh_TW from 'vee-validate/dist/locale/zh_TW'  // vee中文語系
import currency from './filters/currency'
import VueQriously from 'vue-qriously'
import VueAnalytics from 'vue-analytics'
import VueGtm from '@gtm-support/vue2-gtm';

import 'bootstrap/dist/css/bootstrap.css'           // bootstrap
import 'bootstrap-vue/dist/bootstrap-vue.css'       // bootstrap
import 'swiper/dist/css/swiper.css'                  // Swiper
import './styles/front_end.scss'                    // Frontend

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Carousel3d);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(VueLazyLoad);
Vue.use(VueQriously);
Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_ID,
    router,
});
Vue.use(VueGtm, {
    enabled: process.env.NODE_ENV === 'production',
    id: process.env.VUE_APP_GTM_ID,
    // display console logs debugs or not (optional)
    debug: false
})
Vue.filter('currency', currency);

new Vue({
    router, // Vue Router
    store,  // VueX
    render(h) {  // 加載
        return h(App)
    }, // render: WebSite => WebSite(App) es6縮寫
    created(){
        this.$validator.localize('zh_TW',zh_TW);
    }
}).$mount('#app')
